import { IStairConfig, IValidationItem } from '@stair-craft/common/util';

import type { IStairNorms } from '../../norms';
import { validate, validateRailing, withHeadroomHint } from '../../validator';
import { WINDER_ANGLE_DEG } from '../u-shape-calculate-layout/calculate-layout';

// Norm validation: shared riser/tread/angle/headroom/width checks, railing checks,
// plus the winder inner-edge depth check (СП 54.13330) for winder turns.
export function buildValidation(
    config: IStairConfig,
    norms: IStairNorms,
    riserHeight: number,
    treadDepth: number,
    stairAngle: number,
    headroom: number,
    sw: number
): IValidationItem[] {
    const validation: IValidationItem[] = withHeadroomHint(validate(riserHeight, treadDepth, stairAngle, headroom, sw), false);
    validation.push(...validateRailing(config.railing));

    if (config.turnType === 'winder') {
        // СП 54.13330 (former СНиП 2.08.01-89): winder depth is measured norms.winderMeasureOffset from the narrow edge.
        // For the U-shape the narrow (inner) edge sits at radius flightGap/2 from the centre,
        // so the measuring radius is flightGap/2 + norms.winderMeasureOffset.
        const angleRad: number = (WINDER_ANGLE_DEG * Math.PI) / 180;
        const measureRadius: number = config.flightGap / 2 + norms.winderMeasureOffset;
        const actualInnerDepth: number = Math.round(2 * measureRadius * Math.sin(angleRad / 2));
        const winderInnerDepthLabel: string = $localize`:@@valWinderInnerDepth:Глубина забежной у узкого края`;
        const mmUnit: string = $localize`:@@unitMm:мм`;
        const minUnit: string = $localize`:@@unitMin:мин`;

        validation.push({
            code: 'WINDER_INNER_DEPTH',
            severity: actualInnerDepth >= norms.winderMinInnerDepth ? 'ok' : 'error',
            value: actualInnerDepth,
            min: norms.winderMinInnerDepth,
            max: null,
            message: `${winderInnerDepthLabel}: ${String(actualInnerDepth)}${mmUnit} (${minUnit} ${String(norms.winderMinInnerDepth)})`,
        });
    }

    return validation;
}
